// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__HovAA","content":"default_content__gvTfm","column":"default_column__FerWJ"};